import { cn } from '@/lib/utils'

interface BorderBeamProps {
  className?: string
  duration?: string
  delay?: string
  color?: string
  size?: number
}

/**
 * A glowing light dot that travels along the border of its parent.
 * Parent must have `position: relative` and `overflow: hidden` + `rounded-xl`.
 */
export function BorderBeam({
  className,
  duration = '6s',
  delay = '0s',
  color = 'var(--chart-line)',
  size = 80,
}: BorderBeamProps) {
  return (
    <div
      className={cn(
        'pointer-events-none absolute inset-0 overflow-hidden rounded-[inherit]',
        className,
      )}
      aria-hidden="true"
    >
      <div
        className="border-beam-dot absolute"
        style={
          {
            '--border-beam-duration': duration,
            '--border-beam-delay': delay,
            '--border-beam-color': color,
            '--border-beam-size': `${size}px`,
          } as React.CSSProperties
        }
      />
    </div>
  )
}
